module.exports = __webpack_public_path__ + "media/bundles/YoupiJob/assets/images/baby-sitting/child3-25efc16afe2df0159661424af4de84ee.svg";